import { render } from "./AppLink.vue?vue&type=template&id=58537284&bindings={\"path\":\"props\",\"external\":\"props\",\"label\":\"props\",\"icon\":\"props\",\"navLink\":\"options\",\"linkType\":\"options\"}"
import script from "./AppLink.vue?vue&type=script&lang=js"
export * from "./AppLink.vue?vue&type=script&lang=js"
script.render = render

export default script